var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'דיווחת על מספר לא מזוהה',"text":'חסמנו את הגישה לתזרים, הצוות שלנו עובד לטפל בבעיה בהקדם האפשרי!',"icon-type":'danger'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }